const getFullName = (user): string => [user.firstName, user.lastName].filter((n) => n).join(' ')

export { getFullName }
